/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs */

const en_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent out your meeting rooms, event spaces, and more to non-members.`)
};

const de_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermiete deine Meetingräume, Eventflächen und andere Ressourcen an Nicht-Mitglieder.`)
};

const es_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquila tus salas de reuniones, espacios para eventos y otros recursos a personas que no son miembros.`)
};

const fr_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Louez vos salles de réunion, vos espaces événementiels, etc. aux non-membres.`)
};

const it_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affitta le tue sale riunioni, spazi per eventi e altro a non membri.`)
};

const pt_br2_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugue suas salas de reunião, espaços para eventos e mais para não-membros.`)
};

const pl_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wynajmuj swoje sale konferencyjne, przestrzenie eventowe i więcej osobom niebędącym członkami.`)
};

const hu_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adja bérbe tárgyalóit, rendezvénytereit és egyebeket nem tagoknak.`)
};

const ro_admin_dashboard_external_bookings_trial_activity_content = /** @type {(inputs: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inchiriati salile de intalniri, spatiile pentru evenimente si altele catre non-membri.`)
};

/**
* | output |
* | --- |
* | "Rent out your meeting rooms, event spaces, and more to non-members." |
*
* @param {Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_external_bookings_trial_activity_content = /** @type {((inputs?: Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_External_Bookings_Trial_Activity_ContentInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_external_bookings_trial_activity_content(inputs)
	if (locale === "de") return de_admin_dashboard_external_bookings_trial_activity_content(inputs)
	if (locale === "es") return es_admin_dashboard_external_bookings_trial_activity_content(inputs)
	if (locale === "fr") return fr_admin_dashboard_external_bookings_trial_activity_content(inputs)
	if (locale === "it") return it_admin_dashboard_external_bookings_trial_activity_content(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_external_bookings_trial_activity_content(inputs)
	if (locale === "pl") return pl_admin_dashboard_external_bookings_trial_activity_content(inputs)
	if (locale === "hu") return hu_admin_dashboard_external_bookings_trial_activity_content(inputs)
	return ro_admin_dashboard_external_bookings_trial_activity_content(inputs)
});
export { admin_dashboard_external_bookings_trial_activity_content as "admin.dashboard.external_bookings_trial_activity_content" }